export const resourceTitle = "Consulta de Transportadoras";

export const resourceKey = "transportadora/geral/filtro";
export const resourceKeyItem = "transportadora/geral";

export const idKey = "id";

export const headers = [
  { label: "Checkbox", key: "checkbox", isVisible: true },
  { label: "ID", key: "id", isVisible: true },
  { label: "Nome", key: "nomefantasia", isVisible: true },
  { label: "CPF ou CNPJ", key: "cpfcnpj", isVisible: true },
  { label: "Ativo", key: "ativo", isVisible: true },
];
